(function () {
  var BRIDGE_URL = "/apps/elegante-consent-tracking";
  var STORAGE_KEY = "rybbit_visitor_id";

  function getVisitorId() {
    var id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random());
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  }

  function post(consent) {
    fetch(BRIDGE_URL + "/consent", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({
        visitor_id: getVisitorId(),
        marketing: !!consent.marketingAllowed,
        analytics: !!consent.analyticsAllowed,
        preferences: !!consent.preferencesAllowed,
        saleOfData: !!consent.saleOfDataAllowed,
        pathname: window.location.pathname,
        shop_domain: window.location.hostname
      })
    }).catch(function () {
      // Fail silently - never block the storefront on analytics.
    });
  }

  // Always send every visitorConsentCollected event. The bridge server
  // decides (durably, from its own database) whether this is the visitor's
  // first-ever decision or a later change, so this is correct even if
  // localStorage is cleared between events. event.detail carries the flags
  // directly (marketingAllowed, analyticsAllowed, preferencesAllowed,
  // saleOfDataAllowed, plus first/thirdPartyMarketingAllowed) - confirmed by
  // logging the live event, since Shopify's docs describe a differently
  // named/shaped payload (customerPrivacy.analyticsProcessingAllowed etc.)
  // than what's actually emitted.
  document.addEventListener("visitorConsentCollected", function (event) {
    post(event.detail || {});
  });
})();